import * as React from "react";
import {
    IGenericUserProps,
    genericMapStateToProps,
} from "../../../DataClasses/GenericUser";
import { Theme, createStyles, } from '@mui/material/styles';;
import { WithStyles, withStyles } from '@mui/styles';;
import idssStyle from "../../../Configuration/SharedStyling";
import { connect } from "react-redux";
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2 as Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { ISubOrgVendor } from "../../../DataClasses/SubOrgVendor";
import { Redirect } from "react-router-dom";
import AdministrationService from "../../Services/AdministrationService";
import { AjaxError } from "rxjs/ajax";
import { InfoOutlined } from "@mui/icons-material";
import { firstValueFrom } from 'rxjs';
import SharedMaterialReactTable, { ISharedTableColumn } from "../../Shared/MaterialReactTable";

const styles = (theme: Theme) => createStyles({
    ...idssStyle(theme),
    paperStyle: {
        flexGrow: 1,
        padding: theme.spacing(2, 2),
    }
});
interface LocalProps {
    productYear: number
}
interface IVendorOrgMapStateStore {
    isLoading: boolean;
    showInvalidOnly: boolean;
    redirect: boolean,
    mappingData: ISubOrgVendor[],
    tableData: ISubOrgVendor[],
    showHedis: boolean,
    showCahps: boolean,
    showHos: boolean,
    openReadMe: boolean
}

type Props = LocalProps & WithStyles<typeof styles>;

class VendorOrgMapView extends React.Component<
    IGenericUserProps & Props,
    IVendorOrgMapStateStore
> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: true,
            showInvalidOnly: false,
            redirect: false,
            mappingData: [],
            tableData: [],
            showCahps: false,
            showHedis: true,
            showHos: false,
            openReadMe: false
        }
    }

    public componentDidMount() {
        this.refreshModel();
    }

    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }

    private setRedirectState() {
        this.setState({ redirect: true });
    }

    private renderSubIdColumn = (rowData: any) => {
        return (
            <Tooltip title="Click to visit the Submission Page">
                <a href={'/submissionHome/' + rowData.submissionId + '/' + rowData.component.replace("HEDIS", "DST") + '/' + rowData.productLine}>{rowData.submissionId}</a>
            </Tooltip>
        );
    };

    private renderColumn = (rowData: any, field: string, options: { isHedisColumn?: boolean; isNonHedisColumn?: boolean; isAuditColumn?: boolean } = {}) => {
        const { isHedisColumn = false, isNonHedisColumn = false, isAuditColumn = false } = options;

        const value = rowData[field];
        let isInvalidValue = (value === null || value.length === 0 || value <= 0);
        const isHedis = (rowData.component === 'HEDIS');

        if (isHedisColumn) {
            isInvalidValue = isHedis && isInvalidValue;
        } else if (isNonHedisColumn) {
            isInvalidValue = !isHedis && isInvalidValue;
        } else if (isAuditColumn) {
            const isAuditRequired = (rowData.isAuditRequired === 'Yes');
            isInvalidValue = isAuditRequired && isInvalidValue;
        }

        const style = isInvalidValue ? { backgroundColor: 'yellow', padding: '8px' } : { padding: '8px' };
        return <div style={style}>{value}</div>;
    };

    private renderOrgIdColumn = (rowData: any) => this.renderColumn(rowData, 'orgId');
    private renderOrgNameColumn = (rowData: any) => this.renderColumn(rowData, 'orgName');
    private renderSoftwareVendorIdColumn = (rowData: any) => this.renderColumn(rowData, 'softwareVendorId', { isHedisColumn: true });
    private renderSoftwareVendorNameColumn = (rowData: any) => this.renderColumn(rowData, 'softwareVendorName', { isHedisColumn: true });
    private renderComponentVendorIdColumn = (rowData: any) => this.renderColumn(rowData, 'componentVendorId', { isNonHedisColumn: true });
    private renderComponentVendorNameColumn = (rowData: any) => this.renderColumn(rowData, 'componentVendorName', { isNonHedisColumn: true });
    private renderAuditFirmIdColumn = (rowData: any) => this.renderColumn(rowData, 'auditFirmId', { isAuditColumn: true });
    private renderAuditFirmNameColumn = (rowData: any) => this.renderColumn(rowData, 'auditFirmName', { isAuditColumn: true });

    private getTableColumns = (): ISharedTableColumn<ISubOrgVendor>[] => {
        const columns: ISharedTableColumn<ISubOrgVendor>[] = [
            {
                accessorKey: 'submissionId',
                header: 'SubID',
                enableSorting: true,
                enableFiltering: true,
                Cell: ({ row }) => this.renderSubIdColumn(row.original),
            },
            {
                accessorKey: 'component',
                header: 'Component',
                enableSorting: true,
                enableFiltering: true,
            },
            {
                accessorKey: 'productLine',
                header: 'ProductLine',
                enableSorting: true,
                enableFiltering: true,
            },
            {
                accessorKey: 'orgId',
                header: 'OrgID',
                enableSorting: true,
                enableFiltering: true,
                Cell: ({ row }) => this.renderOrgIdColumn(row.original),
            },
            {
                accessorKey: 'orgName',
                header: 'OrgName',
                enableSorting: true,
                enableFiltering: true,
                Cell: ({ row }) => this.renderOrgNameColumn(row.original),
            },
        ];

        // Add HEDIS-specific columns
        if (this.state.showHedis) {
            columns.push(
                {
                    accessorKey: 'softwareVendorId',
                    header: 'SoftwareVendorId',
                    enableSorting: true,
                    enableFiltering: true,
                    Cell: ({ row }) => this.renderSoftwareVendorIdColumn(row.original),
                },
                {
                    accessorKey: 'softwareVendorName',
                    header: 'SoftwareVendorName',
                    enableSorting: true,
                    enableFiltering: true,
                    Cell: ({ row }) => this.renderSoftwareVendorNameColumn(row.original),
                }
            );
        }

        // Add CAHPS/HOS-specific columns
        if (this.state.showCahps || this.state.showHos) {
            columns.push(
                {
                    accessorKey: 'componentVendorId',
                    header: 'ComponentVendorId',
                    enableSorting: true,
                    enableFiltering: true,
                    Cell: ({ row }) => this.renderComponentVendorIdColumn(row.original),
                },
                {
                    accessorKey: 'componentVendorName',
                    header: 'ComponentVendorName',
                    enableSorting: true,
                    enableFiltering: true,
                    Cell: ({ row }) => this.renderComponentVendorNameColumn(row.original),
                }
            );
        }

        // Add audit columns for HEDIS/CAHPS
        if (this.state.showHedis || this.state.showCahps) {
            columns.push(
                {
                    accessorKey: 'isAuditRequired',
                    header: 'AuditRequired',
                    enableSorting: true,
                    enableFiltering: true,
                },
                {
                    accessorKey: 'auditFirmId',
                    header: 'AuditFirmId',
                    enableSorting: true,
                    enableFiltering: true,
                    Cell: ({ row }) => this.renderAuditFirmIdColumn(row.original),
                },
                {
                    accessorKey: 'auditFirmName',
                    header: 'AuditFirmName',
                    enableSorting: true,
                    enableFiltering: true,
                    Cell: ({ row }) => this.renderAuditFirmNameColumn(row.original),
                }
            );
        }

        return columns;
    };

    public render() {
        if (this.state.redirect) {
            return this.redirectToErrorPage();
        }
        const { classes } = this.props;

        return <Grid container alignItems="flex-end" spacing={2} className={classes.root}>
            <Grid size={3}>
                <Typography variant='h6' color='primary' className={classes.tabTitle}>
                    Mapping List
                    <Tooltip title="How does this page work?">
                        <IconButton onClick={() => this.setState({ openReadMe: true })}>
                            <InfoOutlined />
                        </IconButton>
                    </Tooltip>
                </Typography>
                <Dialog
                    open={this.state.openReadMe}
                    onClose={() => this.setState({ openReadMe: false })}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>{"How does this page work?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            A submission is considered to have valid sub-org-vendor mapping if it satisfies the following criteria:<br />
                            <ul>
                                <li> <b>Organization Mapping</b>: Each submission must have an OrgID that matches a valid OrgName in the Data Warehouse (DW).</li>
                                <li> <b>HEDIS Submissions</b>: For submissions related to DST (HEDIS), there must be a software VendorID that corresponds to a valid OrgName in DW.</li>
                                <li> <b>CAHPS or HOS Submissions</b>: For CAHPS or HOS submissions, a ComponentVendorID with an accurate OrgName mapping in DW is required.</li>
                                <li> <b>Audit Firm Mapping (HEDIS/CAHPS)</b>: If a submission has AuditRequired as Yes, there must be a AuditFirmId that corresponds to a valid OrgName in DW.</li>
                            </ul>
                            If a submission does not meet the specified criteria, it will be <span style={{ backgroundColor: 'yellow' }}>highlighted in yellow</span> in the table. If the "Display only invalid mappings" option is checked, the table will show only the submissions that violate the specified criteria.<br />
                            The table offers filters to display only HEDIS, CAHPS, or HOS submissions as needed.<br />
                            Software Vendors are associated with HEDIS submissions, and Component Vendors with CAHPS and HOS submissions. Therefore:<br />
                            <ul>
                                <li>Selecting only HEDIS will only display Software Vendor IDs and Names while hiding Component Vendor information.</li>
                                <li>Selecting only CAHPS or/and HOS will display only Component Vendor IDs and Names.</li>
                            </ul>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ openReadMe: false })}>CLOSE</Button>
                    </DialogActions>
                </Dialog>
            </Grid>
            <Grid size={3}>
                <Checkbox
                    checked={this.state.showInvalidOnly}
                    onChange={() => {
                        this.setState({
                            showInvalidOnly: !this.state.showInvalidOnly
                        }, () => {
                            this.PopulateTableData()
                        });
                    }}
                    color="primary"
                />
                <small><strong>Display only invalid mappings</strong></small>
            </Grid>
            <Grid size={6}>
                Type(s) to View:
                <Checkbox
                    checked={this.state.showHedis}
                    onChange={() => {
                        this.setState({
                            showHedis: !this.state.showHedis
                        }, () => {
                            this.PopulateTableData()
                        });
                    }}
                    color="primary"
                />
                <small><strong>HEDIS</strong></small>
                <Checkbox
                    checked={this.state.showCahps}
                    onChange={() => {
                        this.setState({
                            showCahps: !this.state.showCahps
                        }, () => {
                            this.PopulateTableData()
                        });
                    }}
                    color="primary"
                />
                <small><strong>CAHPS</strong></small>
                <Checkbox
                    checked={this.state.showHos}
                    onChange={() => {
                        this.setState({
                            showHos: !this.state.showHos
                        }, () => {
                            this.PopulateTableData()
                        });
                    }}
                    color="primary"
                />
                <small><strong>HOS</strong></small>
            </Grid>
            <Grid size={12}>
                <SharedMaterialReactTable
                    data={this.state.tableData}
                    columns={this.getTableColumns()}
                    title="Vendor Org Mapping"
                    isLoading={this.state.isLoading}
                    enablePagination={true}
                    enableSorting={true}
                    enableFiltering={true}
                    enableColumnActions={true}
                    enableRowActions={false}
                    initialState={{
                        pagination: { pageIndex: 0, pageSize: 25 },
                    }}
                    muiPaginationProps={{
                        rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100],
                    }}
                    emptyMessage="No vendor org mappings found."
                    key={`${this.state.showHedis}-${this.state.showCahps}-${this.state.showHos}`}
                />
            </Grid>
        </Grid>
    }

    private async refreshModel() {
        this.setState({ isLoading: true });

        const retval: ISubOrgVendor[] = await firstValueFrom(
            AdministrationService.GetSubOrgVendorMap$(this.props.user)
        );
        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        }
        else {
            this.setState({
                mappingData: retval
            });
        }
        this.PopulateTableData();
        this.setState({ isLoading: false });
    }

    private PopulateTableData = () => {
        let tableData: ISubOrgVendor[] = [];
        this.state.mappingData.forEach((item) => {
            let showBasedOnInvalidOnlySelection = this.state.showInvalidOnly ? !item.isValid : true;
            if (showBasedOnInvalidOnlySelection && this.state.showHedis && item.component === "HEDIS") {
                tableData.push(item);
            }
            if (showBasedOnInvalidOnlySelection && this.state.showCahps && item.component.includes("CAHPS")) {
                tableData.push(item);
            }
            if (showBasedOnInvalidOnlySelection && this.state.showHos && item.component === "HOS") {
                tableData.push(item);
            }
        });
        this.setState({
            tableData: tableData
        });
    }
}

const VendorOrgMapPageWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(VendorOrgMapView);

// STYLES CONTAINER
const VendorOrgMapPage = withStyles(styles)(
    VendorOrgMapPageWithState
);

export default VendorOrgMapPage;
